import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useCreateGalleryEventMutation } from "./galleryEventsApiSlice";
import { useGetGalleryCategoriesQuery } from "../galleryCategories/galleryCategoriesApiSlice";

import "./galleryEvent.css";

const NewGalleryEvent = () => {

  const navigate = useNavigate();

  const { data: categoriesData } = useGetGalleryCategoriesQuery();

  const [createGalleryEvent, { isLoading }] =
    useCreateGalleryEventMutation();

  const categories = categoriesData?.data || [];

  const [formData, setFormData] = useState({
    title: "",
    category: "",
    description: "",
    eventDate: new Date().toISOString().slice(0, 10),
    location: "",
    mantra: "",
    order: 0,
    isPublished: true,
  });

  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]:
        type === "checkbox"
          ? checked
          : type === "number"
          ? Number(value)
          : value,
    });

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      await createGalleryEvent(formData).unwrap();

      alert("Event created successfully");

      navigate("/dashboard/gallery-events");

    } catch (err) {

      alert(err?.data?.message || "Error creating event");

    }

  };

  return (
    <div className="admin-container">

      <div className="admin-header">
        <h2>Add Gallery Event</h2>
      </div>

      <form onSubmit={handleSubmit} className="admin-form">

        <div className="form-group">
          <label>Event Title</label>

          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Example: Guru Poornima"
            required
          />
        </div>

        <div className="form-group">
          <label>Category</label>

          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
          >
            <option value="">Select Category</option>

            {categories.map((cat) => (
              <option key={cat._id} value={cat._id}>
                {cat.title}
              </option>
            ))}

          </select>
        </div>

        <div className="form-group">
          <label>Event Date</label>

          <input
            type="date"
            name="eventDate"
            value={formData.eventDate}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Location</label>

          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleChange}
            placeholder="Event location"
          />
        </div>

        <div className="form-group">
          <label>Mantra</label>

          <input
            type="text"
            name="mantra"
            value={formData.mantra}
            onChange={handleChange}
            placeholder="Optional spiritual message"
          />
        </div>

        <div className="form-group">
          <label>Description</label>

          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Write event details..."
          />
        </div>

        <div className="form-group">
          <label>Display Order</label>

          <input
            type="number"
            name="order"
            value={formData.order}
            onChange={handleChange}
          />
        </div>

        <div className="form-group checkbox-group">

          <label>

            <input
              type="checkbox"
              name="isPublished"
              checked={formData.isPublished}
              onChange={handleChange}
            />

            Published

          </label>

        </div>

        <button
          type="submit"
          className="btn-primary"
          disabled={isLoading}
        >

          {isLoading ? "Creating..." : "Create Event"}

        </button>

      </form>

    </div>
  );
};

export default NewGalleryEvent;